/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum GetAdminDashboardStats200RecentActivityItemType {
  user_signup = 'user_signup',
  booking = 'booking',
  professional_verified = 'professional_verified',
  activity_created = 'activity_created'
}
